import store from '../store'

const config = {
    apiUrl: location.hostname !== 'localhost' ? `${location.origin}/api.php` : 'https://kreator.editello.com/api.php'
}

export default {
    getAll,
    getOneById,
    getOneByCode,
    setTemplate,
    deleteTemplate
};

function getAll() {

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`
        }
    };

    return fetch(`${config.apiUrl}?action=templates`, requestOptions).then(handleResponse);
}

function getOneById(id) {

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`
        }
    };

    return fetch(`${config.apiUrl}?action=template&id=${id}`, requestOptions).then(handleResponse);
}

function getOneByCode(code) {

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`
        }
    };

    return fetch(`${config.apiUrl}?action=template&code=${code}`, requestOptions).then(handleResponse);
}

function setTemplate(data) {

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };

    return fetch(`${config.apiUrl}?action=setTemplate`, requestOptions).then(handleResponse);
}

function deleteTemplate(templateId) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: templateId
        })
    };

    return fetch(`${config.apiUrl}?action=deleteTemplate`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}